<template>
    <div class="ui-table-card">
        <div v-if="$slots.toolbar" class="ui-toolbar">
            <slot name="toolbar"></slot>
            <span v-if="clearable || $slots.more" class="ui-toolbar__spacer"></span>
            <v-btn v-if="$slots.more" text class="ui-toolbar__more" :aria-expanded="String(expanded)" @click="expanded = !expanded">
                <v-icon left small>mdi-tune-variant</v-icon>
                {{ expanded ? "Menos filtros" : "Mais filtros" }}
                <span v-if="moreCount" class="ui-tab-count ui-tab-count--attention">{{ moreCount }}</span>
                <v-icon right small>{{ expanded ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
            </v-btn>
            <v-btn v-if="clearable" text class="ui-toolbar__clear" :disabled="!canClear" @click="$emit('clear')">
                <v-icon left small>mdi-restore</v-icon>Limpar
            </v-btn>
        </div>
        <v-expand-transition>
            <div v-if="$slots.more" v-show="expanded" class="ui-toolbar ui-toolbar--more">
                <slot name="more"></slot>
            </div>
        </v-expand-transition>
        <slot></slot>
        <slot name="footer"></slot>
    </div>
</template>

<script>
// Cartao da tabela: linha de filtros (slot toolbar, com "Limpar" opcional),
// filtros extras recolhiveis (slot more, com "Mais filtros" e a contagem de
// filtros extras ativos em more-count), a tabela (slot padrao) e o rodape
// (slot footer, normalmente ui-pagination).
export default {
    name: "UiTableCard",
    props: {
        clearable: { type: Boolean, default: false },
        canClear: { type: Boolean, default: false },
        moreCount: { type: Number, default: 0 },
        // Abre os filtros extras de inicio (ex.: quando ja ha filtro extra ativo).
        moreOpen: { type: Boolean, default: false },
    },
    data() {
        return { expanded: this.moreOpen };
    },
};
</script>
